export default (date = ''): Date => {
  if (date.match('\\d{4}-\\d{2}-\\d{2}') && date.length === 10) {
    return new Date(
      parseInt(date.substring(0, 4), 10),
      parseInt(date.substring(5, 7), 10) - 1,
      parseInt(date.substring(8, 10), 10),
    );
  }
  return undefined;
};
